// Microsoft Application Insights Provider
// Initializes the Application Insights SDK.
// Adapted from angular-appinsights by john hidey.

import angular from "angular";
const AppInsightsModule = require("applicationinsights-js");
const AppInsights = AppInsightsModule.AppInsights;

const appInsightsStub = {
    startTrackPage: angular.noop,
    stopTrackPage: angular.noop,
    trackPageView: angular.noop,
    startTrackEvent: angular.noop,
    stopTrackEvent: angular.noop,
    trackEvent: angular.noop,
    trackDependency: angular.noop,
    trackException: angular.noop,
    trackMetric: angular.noop,
    trackTrace: angular.noop,
    flush: angular.noop,
    setAuthenticatedUserContext: angular.noop,
    clearAuthenticatedUserContext: angular.noop
};

let mSDKInitialized = new WeakMap();

class AppInsightsProvider {
    constructor() {
        mSDKInitialized.set(this, false);
    }

    InitializeSDK(insightsKey) {
        if (angular.isString(insightsKey)) {
            AppInsights.downloadAndSetup({instrumentationKey: insightsKey});
            mSDKInitialized.set(this, true);
        }
        else {
            throw new TypeError("Missing or Invalid Application Insights Instrumentation Key");
        }
    }

    $get() {
        if (mSDKInitialized.get(this) !== true) {
            throw new Error("Cannot Use Application Insights Provider: SDK Not Initialzied.");
        }

        return AppInsights || appInsightsStub;
    }
}

export default AppInsightsProvider;



//////////////////
// WEBPACK FOOTER
// ./src/services/AppInsights/AppInsightsProvider.js
// module id = 9l0p
// module chunks = 1